import MenuService from "../../services/MenuService";

export const MENU_LOAD_START = "MENU_LOAD_START";
export const MENU_LOAD_SUCCESS = "MENU_LOAD_SUCCESS";
export const MENU_LOAD_FAILURE = "MENU_LOAD_FAILURE";

export const loadMenu = (roleCode) => async (dispatch, getState) => {
  const state = getState();
  const existingMenu = state?.menu?.data || [];
  const lastFetchedAt = state?.menu?.lastFetchedAt || null;
  const now = Date.now();
  // If we attempted fetch recently (within 60s), skip to avoid retry storms
  if (lastFetchedAt && now - lastFetchedAt < 60000) {
    return;
  }
  // If menu is already loaded for this session, skip API call
  if (Array.isArray(existingMenu) && existingMenu.length > 0) {
    return;
  }

  dispatch({ type: MENU_LOAD_START });
  try {
    const response = await MenuService.getMenuByRole(roleCode);
    if (response && response.success && response.data) {
      dispatch({ type: MENU_LOAD_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: MENU_LOAD_FAILURE, error: response?.message || 'Failed to load menu' });
    }
  } catch (err) {
    dispatch({ type: MENU_LOAD_FAILURE, error: err.message || 'Failed to load menu' });
  }
};
